import React from 'react';
import '../style/infokontakt.css'
import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';


function Infokontakt() {

    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/kontakt')
    }
  return (
    <div className='infokontakt-container'>
        <div className="box-info">
            <div className="first-text">
                
                
                <Typography variant='h3' className='first-text'>Jetzt Termin vereinbaren</Typography>
               
              
            </div>
            <div className="second-text">
               
                <Typography variant='body1' className='bodytext'>Kontaktieren Sie uns telefonisch, per E-Mail oder über unsere Social-Media-Kanäle, um mit uns in Verbindung zu treten. Wir freuen uns darauf, von Ihnen zu hören und Ihnen zu helfen, die perfekte Lösung für Ihre Anforderungen zu finden..
                
                 </Typography> 
            </div>
            <div className="button-info">
                <Stack>
             <Button variant='contained' onClick={handleClick} className='buttokontankt' 
             sx={{
                width:{
                    xs:100,
                    sm:200,
                    md:300,
                    lg:400,
                    xl:500
                },
                backgroundColor:'var(--mainColor)',
                color:'var(--mainColorLight)',
                fontWeight:'bold',

                
                marginTop:'20px',
                '&:hover': {
                    backgroundColor:'#01b8c3',
                    color:'var(--mainColor)'
                }

        }}>Verbinde jetzt</Button>
            </Stack>
            </div>
        </div>

    </div>
  )
}

export default Infokontakt